module.exports = __webpack_public_path__ + "media/images/entities_logo/logo_ana-a5a7e2ce882698421283e8e5cd1d54bf.png";